// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11n9G","index":"styles_index__qocSL"};